import React from "react";
import styles from "./ContentArticle.module.css";
import HTMLContent from "../HtmlContent";

type ContentArticleType = {
  titleData?: string;
  paragraphData?: string;
  HTMLData?: any;
  split?: number;
  isStudentLife?: boolean;
  isCurriculum?: boolean;
  isContact?: boolean;
}

const ContentArticle = (props: ContentArticleType) => {
  const { titleData, paragraphData, HTMLData, split, isStudentLife, isCurriculum,isContact } = props;
  const _titleData = !isNaN(split)
    ? titleData?.split(" ")?.slice(0, -split).join(" ")
    : titleData;

  const paragraphs =  typeof paragraphData === 'string' 
    ? paragraphData.split("<p>").filter((p) => p.trim())
    : [];
  return (
    <div className={ !isContact && "container section_pading content-article pb-3"}>
      <div className="row">
        {
          isCurriculum && (
            <h6 className={`${styles.headText1}`}>
              {titleData}
            </h6>
          ) || (
            <div className={`title-container ${styles.textContent}`}>
              {titleData !== null && (
                <h1 className={`${styles.headText}`}>
                  {!isStudentLife ? _titleData : titleData}
                </h1>
              )}

              {paragraphs.map((paragraph, index) => (
                <React.Fragment key={index}>
                  <p className={` ${styles.subText}`}>
                    {paragraph.replace("</p>", "")}
                  </p>
                  {index < paragraphs.length - 1 }{" "}
                </React.Fragment>
              ))}

              {HTMLData !== null && <HTMLContent content={HTMLData} />}
            </div>
          )
        }
      </div>
    </div>
  );
};

export default ContentArticle;
